import { render, staticRenderFns } from "./MassCustomerCategoriesStepReview.vue?vue&type=template&id=8839573e&scoped=true&"
import script from "./MassCustomerCategoriesStepReview.vue?vue&type=script&lang=js&"
export * from "./MassCustomerCategoriesStepReview.vue?vue&type=script&lang=js&"
import style0 from "./MassCustomerCategoriesStepReview.vue?vue&type=style&index=0&id=8839573e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8839573e",
  null
  
)

export default component.exports